export default __webpack_public_path__ + "static/media/warning--rickshaws-crossing--g1.57f86968.png";